<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true"></breadcrumb>
    </div>
    <!--    table    -->
    <div class="section-title">
      <div>商品明细</div>
    </div>
    <div class="edit-ctn" id="editCtn">
      <!--      table title      -->
      <div class="div-table-row table-title">
        <div class="div-table-cell" style="width: 15%;flex-grow: 1">图片</div>
        <div class="div-table-cell" style="width: 15%;flex-grow: 1">汽配编码</div>
        <div class="div-table-cell" style="width: 15%">配件名称</div>
        <div class="div-table-cell" style="width: 10%">数量</div>
        <div class="div-table-cell" style="width: 10%">单位</div>
        <div class="div-table-cell" style="width: 10%">
          <span class="color-red">*</span>售价
        </div>
        <div class="div-table-cell" style="width: 10%">总价</div>
        <div class="div-table-cell" style="width: 10%">剩余网销库存数量</div>
      </div>
      <div
        v-bind:key="index"
        class="div-table-row table-item"
        v-for="(item, index) in orderDetailList"
        :ref="'pj' + index"
      >
        <div class="div-table-cell" style="width: 15%;flex-grow: 1">
          <img
            src="../../../assets/images/info.png"
            alt
            title="配件信息"
            class="info-icon"
            @click="showAPMsgDialog(item.GoodsId)"
          />
          <div class="cover">
            <el-image
              style="width: 60px; height: 60px"
              :src="downloadUrl + item.GoodsImg + '?imageView2/2/w/200'"
              :preview-src-list="[downloadUrl + item.GoodsImg]"
            ></el-image>
          </div>
        </div>
        <div class="div-table-cell" style="width: 15%;flex-grow: 1">
          <el-input size="small" placeholder="零件编码" v-model="item.APCode" :disabled="true"></el-input>
        </div>
        <!--        名称            -->
        <div class="div-table-cell" style="width: 15%">
          <el-input size="small" placeholder="配件名称" v-model="item.GoodsName" :disabled="true"></el-input>
        </div>
        <!--        数量            -->
        <div class="div-table-cell" style="width: 10%">
          <el-input type="number" min="1" size="small" v-model="item.Count" :disabled="true"></el-input>
        </div>
        <!--        单位         -->
        <div class="div-table-cell" style="width: 10%">
          <el-input size="small" v-model="item.Unit" :disabled="true"></el-input>
        </div>
        <!--        售价           -->
        <div class="div-table-cell" style="width: 10%">
          <el-input type="number" step="0.01" size="small" v-model="item.SalesPrice" :disabled="true"></el-input>
        </div>
        <!--        总价            -->
        <div class="div-table-cell" style="width: 10%;font-weight:700;">
          <el-input type="number" step="0.01" size="small" v-model="item.TotalPrice" :disabled="true"></el-input>
        </div>
        <div class="div-table-cell" style="width: 10%;font-weight:700;">
          <el-input
            type="number"
            size="small"
            v-model="item.RemainingShareInventory"
            :disabled="true"
          ></el-input>
        </div>
      </div>
      <div class="div-table-row table-bottom">
        <div class="div-table-cell" style="width: 15%"></div>
        <div class="div-table-cell" style="width: 15%;"></div>
        <div class="div-table-cell" style="width: 15%;font-weight:700;">总数量:</div>
        <div class="div-table-cell" style="width: 10%;font-weight:700;">
          <el-tooltip effect="dark" :content="totalCount.toString()" placement="top">
            <span>{{totalCount}}</span>
          </el-tooltip>
        </div>
        <div class="div-table-cell" style="width: 10%;"></div>
        <div class="div-table-cell" style="width: 10%;font-weight:700;">合计:</div>
        <div class="div-table-cell" style="width: 10%;font-weight:700;">
          <el-tooltip effect="dark" :content="summation.toString()" placement="top">
            <span>{{ summation }}</span>
          </el-tooltip>
        </div>
        <div class="div-table-cell" style="width: 10%;"></div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="配件信息"
      :visible.sync="APMsgVisible"
      width="1000px"
    >    
      <div v-if="APMsgVisible">    
        <APMsg
          :dialogFormVisible="APMsgVisible"
          :EntpTempGoodsId="EntpTempGoodsIdEdit"
          @closeDialog="closeAPMsgDialog"
        ></APMsg>
      </div>
    </el-dialog>     
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import APMsg from "@/components/common/APMsg";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    APMsg,
    breadcrumb
  },
  data() {
    return {
      downloadUrl: this.$util.QN_URL_BASE,
      EntpTempGoodsIdEdit: "",
      orderDetailList: [],
      id: "",
      permission: {},
      totalCount: 0,
      summation: 0,
      APMsgVisible: false
    };
  },
  mounted() {
    this.permission = this.$util.getPermission("transToPurchaseOrder");
    this.id = this.$route.query.orderId;
    this.getOrderDetail();
  },
  watch: {
    //计算总数量/合计
    orderDetailList: function(obj) {
      for (let i = 0; i < obj.length; i++) {
        this.totalCount = obj[i].Count + this.totalCount;
        this.summation = obj[i].TotalPrice + this.summation;
      }
    },
    deep: true
  },
  methods: {
    //获取订单详情
    getOrderDetail() {
      this.$util
        .axiosGet({
          url: "/api/ShareInventory/GetSGoodsSalesOrderGoodsList",
          data: { orderId: this.id }
        })
        .then(res => {
          if (res.data) {
            this.orderDetailList = res.data;
          } else {
            this.orderDetailList = [];
          }
        })
        .catch(err => {});
    },
    // 配件信息
    showAPMsgDialog(id) {
      if (id) {
        this.EntpTempGoodsIdEdit = id;
        this.APMsgVisible = true;
      }
    },
    closeAPMsgDialog() {
      this.APMsgVisible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.section-title {
  display: flex;
  justify-content: space-between;
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
  font-weight: bold;
  font-size: @font-sm;
  margin-left: -1px;
  background: @border3Color;
}
.edit-ctn {
  .div-table-cell {
    padding: 0 5px;
  }
}
.business-content-main {
  padding-right: 80px;
}
.table-title {
  height: 50px;
  line-height: 36px;
  text-align: center;
  font-weight: bold;
}
.div-table-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  flex-grow: 1;
}
.table-item {
  position: relative;
}
.table-bottom {
  height: 50px;
}
.div-table-row {
  overflow: inherit;
}
.cover {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;
}
</style>